import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';


type SetPasswordOutput = {
  tokens: {
    access_token: string;
    refresh_token: string;
  };
} | {
  error: 'account_is_created' | 'user_not_found';
};


export type SetPasswordParams = {
  password: string;
  token: string;
  isInviteToken: boolean;
  onboardingTermsAccepted?: boolean;
};


export const setPassword = (params: SetPasswordParams) => {
  return restClient.request<SetPasswordOutput>(
    '/auth/set_password',
    {
      method: 'POST',
      data: snakecaseKeys(params),
    }
  );
};
